export default __webpack_public_path__ + "static/media/shopping _Isometric.0b7635b4.svg";